import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)
const routes = [
    {
        path: '/redirect',
        name: 'redirect',
        component: resolve => require(['@/views/redirect.vue'], resolve),
    },
    {
        path: '/',
        component: resolve => require(['@/views/Home.vue'], resolve),
        children: [
            // {
            //     path: '/api',// api
            //     name: 'api',
            //     component: resolve => require(['@/views/index/apipage.vue'], resolve),
            // },
            {
                path: '/apidel',// api
                name: 'apidel',
                component: resolve => require(['@/views/index/apidel.vue'], resolve),
            },
            {
                path: '/',// 店铺
                name: '/',
                component: resolve => require(['@/views/index/shop.vue'], resolve),
            },
            {
                path: '/goods',// 商品匹配
                name: 'goods',
                component: resolve => require(['@/views/index/goods.vue'], resolve),
            },
            {
                path: '/importgood',// 导入商品
                name: 'importgood',
                component: resolve => require(['@/views/index/importgood.vue'], resolve),
            },
            // {
            //     path: '/orderList',//订单
            //     name: 'orderList',
            //     component: resolve => require(['@/views/index/orderList.vue'], resolve),
            // },
            {
                path: '/logList',//日志
                name: 'logList',
                // meta: { rule: 'logs' },
                component: resolve => require(['@/views/index/logList.vue'], resolve),
            },
            {
                path: '/carrier',// 物流管理
                name: 'carrier',
                // meta: { rule: 'wuliu' },
                component: resolve => require(['@/views/index/carrier.vue'], resolve),
            },
            {
                path: '/order_attribute',// 字段映射
                name: 'order_attribute',
                // meta: { rule: 'yingshe' },
                component: resolve => require(['@/views/index/order_attribute.vue'], resolve),
            },
            {
                path: '/shopsetting',//店铺管理
                name: 'shopsetting',
                // meta: { rule: 'settings' },
                component: resolve => require(['@/views/index/shopsetting.vue'], resolve),
            },
            {
                path: '/user',//用户
                name: 'user',
                // meta: { rule: 'user' },
                component: resolve => require(['@/views/index/user.vue'], resolve),
            },
            {
                path: '/rules',//用户
                name: 'rules',
                // meta: { rule: 'user_auth' },
                component: resolve => require(['@/views/index/rules.vue'], resolve),
            },
            {
                path: '/pageList',
                name: 'pageList',
                component: resolve => require(['@/views/index/pageList.vue'], resolve),
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: resolve => require(['@/views/login/login.vue'], resolve),
    },
    {
        path: '/register',
        name: 'register',
        component: resolve => require(['@/views/login/register.vue'], resolve),
    },
    {
        path: '/password',
        name: 'password',
        component: resolve => require(['@/views/login/password.vue'], resolve),
    },
    {
        path: '/agreement',
        name: 'agreement',
        component: resolve => require(['@/views/login/agreement.vue'], resolve),
    },
    {
        path: '/invite',//邀请用户
        name: 'invite',
        component: resolve => require(['@/views/login/invite.vue'], resolve),
    },
    {
        path: '/404',
        component: () => import('@/views/error/404'),
        hidden: true
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true
    }
]
// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    mode: 'history', // 去掉url中的#
    routes
})
// router.beforeEach((to, from, next) => {
//     if (to.matched.length === 0) {
//         from.path ? next({ name: from.name }) : next('/404')
//     } else {

//         if (to.meta?.rule && roles.indexOf(to.meta.rule) == -1) {
//             next('/404')
//         } else {
//             next()
//         }
//     }
// })

export default router
